// extracted by mini-css-extract-plugin
export default {"root":"dV9yxmC_vedsGJ5jRP07"};